module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chara-content"
  }, [_c('ul', {
    staticClass: "c-tabmenu c-tabmenu_max-200"
  }, [_c('li', {
    staticClass: "c-tabmenu__item"
  }, [_c('router-link', {
    staticClass: "c-tabmenu__link",
    attrs: {
      "to": {
        name: 'story',
        params: {
          story: 'washio'
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-tabmenu__text"
  }, [_vm._v("Washio Sumi Chapter")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "c-tabmenu__item"
  }, [_c('router-link', {
    staticClass: "c-tabmenu__link",
    attrs: {
      "to": {
        name: 'story',
        params: {
          story: 'yusha'
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-tabmenu__text"
  }, [_vm._v("Hero Chapter")])])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "chara-select"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_change_story),
      expression: "!is_change_story"
    }],
    staticClass: "chara-select"
  }, _vm._l((_vm.chara_list), function(chara, index) {
    return _c('chara-thumb', {
      key: index,
      attrs: {
        "story": _vm.story,
        "id": chara.id,
        "thumb": chara.thumb
      }
    })
  }))]), _vm._v(" "), _c('chara-detail')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51c09461"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/chara/chara-content.vue
// module id = 56
// module chunks = 0